<template>
  <div class="content">
   
    <div style="position: fixed;right:10px;top:300px;z-index:1000">
      <Rightnav @showsp="getshow" @runtops="runtop"></Rightnav>
    </div>
    <transition name="slide-fade">
      <div class="Mask" v-if="showquote">
        <div class="mask-main">
          <i @click="mask" class="iconfont icon-guanbi"></i>
          <Freequote></Freequote>
        </div>
      </div>
    </transition>
    <div class="banane">
        <img src="../assets/images/join/top.jpg" oncontextmenu="return false;" />
    </div>
    <div class="main">
      <div class="Join" v-if="showsub" >
        <div class="Join-main wow slideInUp" data-wow-duration="0.7s" data-wow-offset="2">
          <Joinsubmission @showjm="getcuon" @childFn="parentFn"></Joinsubmission>
        </div>
      </div>
      <div class="imgspl">
        <div
          class="titless wow slideInUp"
          data-wow-duration="0.7s"
          data-wow-offset="2"
          style="margin-top: 0px;"
        >
          <img src="../assets/images/join/title.png" oncontextmenu="return false;" />
          <div class="hot1 hot">
            <p>A股上市企业&nbsp;|&nbsp;金牌厨柜出品</p>
            <p>火爆招募</p>
            <p>桔家云整装福建城市运营商</p>
          </div>
        </div>
        <div
          class="wow slideInUp"
          data-wow-duration="0.7s"
          data-wow-offset="2"
          style="margin-top: 0px;"
        >
          <img src="../assets/images/join/jmnr2.jpeg" oncontextmenu="return false;" />
        </div>
        <div
          class="titless wow slideInUp"
          data-wow-duration="0.7s"
          data-wow-offset="2"
          style="margin-top: 0px;"
        >
          <img src="../assets/images/join/title.png" oncontextmenu="return false;" />
          <div class="hot2 hot">
            <p>A股上市企业&nbsp;|&nbsp;金牌厨柜出品</p>
            <p>严峻的形式</p>
            <p>要么破局，要么出局！</p>
          </div>
          <div class="now wow slideInUp" data-wow-duration="0.7s" data-wow-offset="2">
            <div class="font">当前趋势</div>
            <div class="update">
              <div style="float:left;width:49%;height:100%;border-right:1px solid #000">
                <p style="font-weight:bolder">产品消费升级</p>
                <p>单品</p>
                <p>组合</p>
                <p>全屋定制</p>
                <p>整装</p>
              </div>
              <div style="float:left;width:50%;">
                <p style="font-weight:bolder">家装消费升级</p>
                <p>清包</p>
                <p>半包</p>
                <p>全包</p>
                <p>整装</p>
              </div>
            </div>
            <div class="hard">
              <p style="margin:0 0;">产品与家装的发展趋势，同时走到了整装的风口，</p>
              <p style="margin:10px 0;">传统单一产品、单一设计、单一施工的组织将举步维艰！</p>
            </div>
          </div>
        </div>
        <div
          class="titless wow slideInUp"
          data-wow-duration="0.7s"
          data-wow-offset="2"
          style="margin-top: 0px;"
        >
          <img src="../assets/images/join/title.png" oncontextmenu="return false;" />
          <div class="hot3 hot">
            <p>A股上市企业&nbsp;|&nbsp;金牌厨柜出品</p>
            <p>整装+新零售</p>
            <p>未来家装的流量入口</p>
          </div>
        </div>
        <div class="threeTitle wow slideInUp" data-wow-duration="0.7s" data-wow-offset="2">
          <div>
            <p>消费升级</p>
            <p>主要消费转移到80、90后群体</p>
            <p>分散性消费到集约型消费</p>
          </div>
          <div>
            <p>产品变革</p>
            <p>政策影响、技术创新</p>
            <p>从O2O到O+O的新零售模式</p>
          </div>
          <div>
            <p>巨头垄断</p>
            <p>产业巨头凭借资本优势和</p>
            <p>生产优势进入整装产业</p>
          </div>
        </div>
        <div class="difficult wow slideInUp" data-wow-duration="0.7s" data-wow-offset="2">
          <div class="change" style="width:60%;margin:0 auto;margin-bottom: 3rem;">
            <p>整装转型的困难？</p>
          </div>
          <div style="float:left;width:49%;border-right:1px solid #000;font-size:28px;">
            <p>供应链采购成本高、利润低</p>
            <p>材料整合人力物力时间成本高</p>
            <p>品牌无议价能力SKU量大</p>
          </div>
          <div style="float:left;width:50%;;font-size:28px;">
            <p>传统管理模式无信息化效率低</p>
            <p>采购重服务成本高风险大</p>
            <p>营销思维局限缺乏系统经营思维</p>
          </div>
        </div>
        <div class="font">所以，我们来了</div>
        <div class="wow slideInUp" data-wow-duration="0.7s" data-wow-offset="2">
          <img src="../assets/images/join/jmnr7.jpg" oncontextmenu="return false;" />
        </div>
        <div style="width:50%;margin:0 auto;">
          <p style="font-size:2.5rem;color:#000;">金牌厨柜</p>
          <p style="font-size:2.5rem;color:#000;font-weight:bolder;margin-bottom:0px;">中国专业厨柜标准定制者</p>
        </div>
        <div
          class="small wow slideInUp"
          data-wow-duration="0.7s"
          data-wow-offset="2"
          style="margin-bottom:5rem;"
        >
          <img src="../assets/images/join/jmnr8.png" oncontextmenu="return false;" />
        </div>
        <div
          class="titless wow slideInUp"
          data-wow-duration="0.7s"
          data-wow-offset="2"
          style="margin-top: 0px;"
        >
          <img src="../assets/images/join/title.png" oncontextmenu="return false;" />
          <div class="hot4 hot">
            <p>A股上市企业&nbsp;|&nbsp;金牌厨柜出品</p>
            <p>全屋+整装|家具平台模式|整装深度赋能</p>
            <p>福建省内10家会员限额招募</p>
          </div>
        </div>
        <div style="width:80%;margin:0 auto;color:#000;" class="wow slideInUp" data-wow-duration="0.7s" data-wow-offset="2">
          <p style="font-size:3rem;margin-bottom:10px;">利润提升30%+</p>
          <p style="font-size:3rem;margin-top:10px;">行业首创轻服务模式</p>
          <p
            style="font-size:4rem;font-weight:bolder;letter-spacing:10px;margin-top:20px;"
          >轻服务模式|直采=地采</p>
        </div>
        <div class="threeTitle wow slideInUp" data-wow-duration="0.7s" data-wow-offset="2">
          <div>
            <p>桔家云整装</p>
            <p>供应链整合&nbsp;物流体系建设</p>
            <p>信息化开发&nbsp;产品研发</p>
            <p>全面帮扶</p>
          </div>
          <div>
            <p>城市运营商</p>
            <p>共享生活美学馆</p>
            <p>苏宁国美模式&nbsp;行业整合</p>
            <p>B端交付&nbsp;服务商</p>
          </div>
          <div>
            <p>会员装企</p>
            <p>C端销售&nbsp;材料展示</p>
            <p>利润设计&nbsp;团队建设</p>
            <p>营销活动</p>
          </div>
        </div>
        <div class="alltype wow slideInUp" data-wow-duration="0.7s" data-wow-offset="2">
          <div class="typeimg">
            <img src="../assets/images/join/5.png" alt />
          </div>
          <div class="typeright">
            <p>全品类模式</p>
            <p style="margin: 0 0;">从主材到软装配饰、家电、智能化、实现个性化、智能化一站式解决方案；</p>
            <p style="margin: 0 0;">自有产品+品牌产品整合，构建供应链体系生态系统。</p>
            <p style="margin-bottom: 0px;font-weight:bolder">一个整装零售店，一站式拎包入住服务。</p>
            <p style="margin: 0 0;font-weight:bolder">家装像逛超市一样简单！</p>
          </div>
        </div>
        <div class="five wow slideInUp" data-wow-duration="0.7s" data-wow-offset="2">
          <div v-for="(item,index) in five" :key="index" style="width:18%;position:relative;">
            <img :src="item.imgurl" alt />
            <div style="position:absolute;width:207px;top:25px;left:18px">
              <p style="font-size: 25px;color: #fff;text-align:center;font-weight:bolder">{{item.title}}</p>
              <p style="font-size: 20px;color: #fff;text-align:left;padding: 0px 10px">{{item.cont1}}</p>
              <p style="font-size: 20px;color: #fff;text-align:left;padding: 0px 10px">{{item.cont2}}</p>
            </div>
          </div>
        </div>
        <div style="width:100%;height:358px" class="wow slideInUp" data-wow-duration="0.7s" data-wow-offset="2">
          <div style="width:40%;height:100%;float:left;margin-left: 5%;"><img src="../assets/images/join/hands1.jpg" alt=""></div>
          <div style="width:40%;height:100%;float:left;margin-left: 5%;"><img src="../assets/images/join/hands2.jpg" alt=""></div>
        </div>
        <div class="fivetitle wow slideInUp" data-wow-duration="0.7s" data-wow-offset="2">
          <div class="fivecont" v-for="(item,index) in fivetitle" :key="index">
            <p>{{item.p1}}</p>
            <p>{{item.p2}}</p>
            <p>{{item.p3}}</p>
            <div class="fivetop">{{item.title}}</div>
          </div>
        </div>
        <div class="font">服务流程</div>
        <div class="procedure wow slideInUp" data-wow-duration="0.7s" data-wow-offset="2">
          <div class="protop" style="height:180px;">
            <div>获客</div>
            <div>→</div>
            <div>产品研发</div>
            <div>→</div>
            <div>设计出图</div>
            <div>→</div>
            <div>预算报价</div>
            <div>→</div>
            <div>下单</div>
          </div>
          <div style="width:100%;height:92px;">
            <div style="float:right;width:17%;font-size: 60px;color:#000">↓</div>
          </div>
          <div class="probot" style="height:180px;">
            <div>安装交付</div>
            <div>←</div>
            <div>人员协同</div>
            <div>←</div>
            <div>施工</div>
            <div>←</div>
            <div>配送</div>
            <div>←</div>
            <div>采购</div>
          </div>
        </div>
        <div class="font">如何加入我们</div>
        <div class="threeTitle second wow slideInUp" data-wow-duration="0.7s" data-wow-offset="2" style="margin-bottom:4rem;">
          <div>
            <p>意向沟通</p>
            <p>背景调查</p>
            <p>合作初审</p>
          </div>
          <div>
            <p>相互考察</p>
            <p>合作面谈</p>
          </div>
          <div>
            <p>意向协议</p>
            <p>经营沟通</p>
            <p>深入沟通</p>
          </div>
          <div>
            <p>正式合作</p>
            <p>采购任务</p>
            <p>会员授牌</p>
          </div>
        </div>
        <div
          class="titless wow slideInUp"
          data-wow-duration="0.7s"
          data-wow-offset="2"
          style="margin-top: 0px;"
        >
          <img src="../assets/images/join/title.png" oncontextmenu="return false;" />
          <div class="hot5 hot">
            <p>A股上市企业&nbsp;|&nbsp;金牌厨柜出品</p>
            <p>会员费用</p>
            <p>2万保证金&nbsp;1万加盟费</p>
          </div>
        </div>
        <div class="procedure vips wow slideInUp" data-wow-duration="0.7s" data-wow-offset="2">
        <div class="protop vip" style="height:180px;">
          <div>前期增值服务</div>
            <div>+</div>
            <div>中期无忧服务</div>
            <div>+</div>
            <div>后期托管服务</div>
            <div>=</div>
            <div>全程无忧服务</div>
          </div>
        </div>
        <div class="fivetitle wow slideInUp" data-wow-duration="0.7s" data-wow-offset="2">
          <div class="fivecont last" >
            <p>市场定位成本核算</p>
            <p>产品研发导入</p>
            <p>品牌建设及管理规范</p>
            <p>户型设计VR全景效果</p>
            <div class="fivetop">前期增值服务</div>
          </div>
          <div class="fivecont last" >
            <p>流量分配</p>
            <p>市场规划渠道整合</p>
            <p>供应链服务</p>
            <p>施工标准化施工监管</p>
            <div class="fivetop">中期增值服务</div>
          </div>
          <div class="fivecont last">
            <p>验收：高标准验收</p>
            <p>售后：全程售服热线</p>
            <p>质保：终身维护</p>
            <div class="fivetop">后期托管服务</div>
          </div>
        </div>
        <div class="font">会员装企授权书</div>
        <div
          class="joinimg wow slideInUp"
          data-wow-duration="0.7s"
          data-wow-offset="2"
          style="margin-top: 0px; display:flex;justify-content: space-around; width:100%;"
        >
          <div>
            <img src="../assets/images/join/join1.jpg" alt />
          </div>
          <div>
            <img src="../assets/images/join/join2.jpg" alt />
          </div>
          <div>
            <img src="../assets/images/join/join3.jpg" alt />
          </div>
        </div>
        <div
          class="joinimg wow slideInUp"
          data-wow-duration="0.7s"
          data-wow-offset="2"
          style="margin-top: 0px; display:flex;justify-content: space-around; width:100%;"
        >
          <div>
            <img src="../assets/images/join/join4.jpg" alt />
          </div>
          <div>
            <img src="../assets/images/join/join5.jpg" alt />
          </div>
          <div>
            <img src="../assets/images/join/join6.jpg" alt />
          </div>
        </div>
        <div
          class="wow slideInUp"
          data-wow-duration="0.7s"
          data-wow-offset="2"
          style="margin-bottom: 50px;"
        >
          <img src="../assets/images/join/jmnr20.png" oncontextmenu="return false;" />
        </div>
      </div>
    </div>
    <div>
      <BottomFoot></BottomFoot>
    </div>
  </div>
</template>
<script>
import Vue from "vue";

import BottomFoot from "../components/BottomFoot.vue";
import Joinsubmission from "../components/Joinsubmission.vue";
import Rightnav from "../components/Rightnav.vue";
import Freequote from "../components/Freequote.vue";
import WOW from "wowjs";
export default {
  components: {
  
    BottomFoot,
    Joinsubmission,
    Rightnav,
    Freequote
  },
  metaInfo() {
    return {
      meta: [
        {
          name: "description",
          content:
            "桔家云整装、整装招商、整装平台、盈利、利润、火爆、最强桔家云整装，由金牌厨柜出品，拥有雄厚的资金实力，以及行业领先的资源、渠道整合能力。一键打通设计、订单、生产、物流、仓储、安装、施工监控等泛家装各环节，为全国装企、设计师、施工队等组织赋能，向消费者提供更全面、更高效、更优质的整体家装解决方案。"
        }
      ]
    };
  },
  data() {
    return {
      nub: "5",
      showquote: false,
      topnub: 0,
      showsub:true,
      code:'',
      five: [
        {
          title: "硬软装一体化设计",
          cont1: "设计软件  海量素材",
          cont2: "所见即所得",
          imgurl: require("../assets/images/join/one.png")
        },
        {
          title: "供应链整合",
          cont1: "全产业链整装产品一线品牌产品",
          cont2: "F2C模式 轻服务 价格优势 提升利润",
          imgurl: require("../assets/images/join/two.png")
        },
        {
          title: "信息化管理",
          cont1: "云商场5000+sku材料清单一键生成",
          cont2: "交付全过程监控",
          imgurl: require("../assets/images/join/three.png")
        },
        {
          title: "产品研发",
          cont1: "C端需求满足生活方式",
          cont2: "研发差异化竞争",
          imgurl: require("../assets/images/join/four.png")
        },
        {
          title: "运营帮扶",
          cont1: "金牌大学全年课程装企管理体系搭建",
          cont2: "资源嫁接 营销支持",
          imgurl: require("../assets/images/join/five.png")
        }
      ],
      fivetitle: [
        {
          title: "精准营销系统",
          p1: "精准广告推送",
          p2: "渠道营销平台",
          p3: ""
        },
        {
          title: "销售设计系统",
          p1: "所见即所得",
          p2: "效果图设计",
          p3: "下单审批管理"
        },
        {
          title: "精准营销系统",
          p1: "400客服系统",
          p2: "客户关怀系统",
          p3: ""
        },
        {
          title: "项目调度系统",
          p1: "项目安排调度",
          p2: "项目进度反馈",
          p3: ""
        },
        {
          title: "供应链管理",
          p1: "产品及库存管理",
          p2: "订单管理系统",
          p3: "财务管理系统"
        }
      ],
      jmshow: true
    };
  },
  mounted() {
    this.$router.afterEach((to, from, next) => {
      window.scrollTo(0, 0);
    }),
      new WOW.WOW().init();
  },
  methods: {
    getshow(data) {
      //console.log("data", data);
      this.showquote = data;
    },
    mask() {
      this.showquote = false;
    },
    runtop(data) {
      document.documentElement.scrollTop = data;
    },
    parentFn(payload) {
        this.code = payload;
        console.log("iiiii",this.code)
        if(this.code==0){
          this.showsub=false;
        }
      },
    getcuon(data) {
      //console.log(data);
      if (data == 0) {
        this.jmshow = true;
      } else {
        this.jmshow = false;
      }
    }
  },
  created: function() {
    const self = this;
  }
};
</script>
<style scoped>
.content {
  width: 100%;
}
.head {
  width: 100%;
  overflow: hidden;
  position: fixed;
  top: 0;
  z-index: 1000;
}
.main {
  width: 1340px;
  margin: 0 auto;
  margin-top: 93px;
}
.Join-main {
  width: 80%;
  margin: 0 auto;
  height: 400px;
  border-top-right-radius: 100px;
  border-bottom-left-radius: 100px;
  background: #b31d25;
}
.el-carousel__item img {
  width: 100%;
  height: 100%;
  margin: 0;
}
.titless {
  position: relative;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.Join {
  margin-top: 2rem;
}
.joinimg > div {
  width: 30%;
}
.joinus {
  position: absolute;
  top: 0;
  left: 30%;
}
.joinus p:first-child {
  font-size: 7rem;
  color: #fff;
  font-weight: bolder;
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.joinus p:last-child {
  font-size: 2.5rem;
  color: #fff;
  margin: 0 0;
}
.hot {
  position: absolute;
  color: #fff;
  top: 2.8rem;
}
.hot p:first-child {
  font-size: 20px;
  letter-spacing: 5px;
  font-weight: bold;
  margin-bottom: 10px;
}
.hot p:nth-child(2) {
  font-size: 5rem;
  letter-spacing: 25px;
  font-weight: bolder;
  margin: 0 0;
}
.hot p:nth-child(3) {
  font-size: 1.6rem;
  letter-spacing: 10px;
  margin: 0 0;
}
.hot1 {
  left: 34.6%;
}
.hot2 {
  left: 32%;
}
.hot3 {
  left: 29%;
}
.hot4 {
  left: 20%;
}
.hot5 {
  left: 35%;
}
.hot4 p:nth-child(2) {
  font-size: 2rem;
  letter-spacing: 15px;
  margin-top: 2rem;
  margin-bottom: 1.7rem;
}
.update div:first-child p,
.difficult div:nth-child(2) p {
  width: 80%;
  text-align: right;
  font-size: 2.5rem;
  color: #000;
}
.update div:nth-child(2) p,
.difficult div:nth-child(3) p {
  width: 80%;
  text-align: left;
  font-size: 2.5rem;
  float: right;
  margin-bottom: 0px;
  color: #000;
}
.difficult div:nth-child(2) p,
.difficult div:nth-child(3) p {
  font-size: 28px;
  width: 87%;
}
.update {
  width: 800px;
  height: 500px;
  margin: 0 auto;
  margin-bottom: 5rem;
}
.hard {
  width: 900px;
  margin: 0 auto;
  margin-bottom: 5rem;
  font-size: 28px;
  letter-spacing: 5px;
  color: #606266;
}
.threeTitle {
  width: 100%;
  display: flex;
  justify-content: space-around;
}
.threeTitle > div p {
  font-size: 28px;
  color: #000;
  letter-spacing: 4px;
}
.threeTitle > div p:first-child,
.difficult .change p {
  width: 80%;
  margin: 0 auto;
  font-size: 2.5rem;
  padding-bottom: 5px;
  font-weight: bolder;
  border-bottom: 10px solid #b31d25;
  letter-spacing: 5px;
  color: #000;
}
.second > div p:first-child {
  width: 100%;
}
.difficult .change p {
  width: 90%;
}
.difficult {
  width: 70%;
  height: 360px;
  margin: 0 auto;
}
.alltype {
  width: 100%;
  height: 600px;
}
.typeimg {
  float: left;
  width: 40%;
  height: 100%;
}
.typeright {
  float: left;
  width: 50%;
  height: 100%;
  text-align: left;
  margin-left: 3%;
  color: #000;
}
.typeright p {
  font-size: 26px;
}
.typeright p:first-child {
  width: 34.5%;
  font-size: 2.5rem;
  padding-bottom: 5px;
  font-weight: bolder;
  border-bottom: 10px solid #b31d25;
  letter-spacing: 5px;
  margin-top: 36%;
}
.typeimg img {
  width: 100%;
}
.fivetitle,
.five {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.fivecont {
  width: 17%;
  color: #000;
  position: relative;
  font-size: 25px;
  border-left: 10px solid #b31d25;
  border-right: 10px solid #b31d25;
  border-bottom: 10px solid #b31d25;
  border-top: 4rem solid #b31d25;
}
.fivetop {
  position: absolute;
  top: -48px;
  left: 40px;
  color: #fff;
}
.procedure {
  width: 100%;
  height: 500px;
}
.protop{
  width: 100%;
  height: 180px;
}
.protop div:nth-child(odd),.probot div:nth-child(odd){
  width: 12%;
  height: 165px;
  line-height: 165px;
  border-radius: 50%;
  font-size: 30px;
  border: 7px solid #b31d25;
  color: #000;
  float: left; 
  margin-left: 4.5%
}
.protop div:nth-child(even),.probot div:nth-child(even){
  width: 1%;
  height: 165px;
  line-height: 165px;
  font-size: 60px;
  float: left; 
  color: #000;
  margin-left: 1.5%
}
.vip div:nth-child(even){
  height: 200px;
  line-height: 200px;
  margin-left: 2.5%;
}
.vip div:nth-child(odd){
  width: 15%;
  height: 200px;
  line-height: 200px;
  margin-left: 5.2%;
}
.vips{
  height: 250px;
}
.last{
  width: 28%;
}
.last .fivetop{
  left: 99px;
  top: -52px;
  font-size: 30px;
}
.iconfont {
  font-size: 100px;
}
/* p {
  text-align: left;
  margin-block-start: 0em;
  margin-block-end: 0em;
  color: rgb(153, 153, 153);
  line-height: 29px;
  font-size: 14px;
} */
.el-button--default {
  width: 100%;
  background: #b31d25;
  border: 0px;
  color: #fff;
}
.Mask {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1000;
}
.mask-main {
  border-radius: 15px;
  text-align: center;
  width: 50%;
  height: 60%;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  background-color: white;
  z-index: 10000;
}
.icon-guanbi {
  font-size: 25px;
  position: absolute;
  right: 11px;
  top: 5px;
  line-height: normal;
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.banane {
  width: 80%;
  height: 770px;
  margin: 0 auto;
  margin-top: 126px;
}
.banane  img {
  width: 100%;
  height: 100%;
}
.imgspl {
  width: 100%;
  margin-top: 6rem;
}
.imgspl > div {
  margin-top: 5rem;
}
.imgspl img {
  width: 100%;
  height: 100%;
}
.font {
  background: #b31d26;
  color: white;
  font-size: 40px;
  width: 320px;
  margin: 0 auto;
  margin-top: 5rem;
  margin-bottom: 5rem;
  font-weight: 500;
  height: 70px;
  border-radius: 10px;
  line-height: 70px;
  text-align: center;
}
</style>
